module.exports = __webpack_public_path__ + "img/704c9d4.png";